import { AxiosResponse } from 'axios';
import api from '.';

export const getVinData = (id: any): Promise<AxiosResponse> => api.get(`/api/v1/vehicle/decode/${id}`);
